import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Typography, Alert } from "@mui/material";
import { jwtDecode } from "jwt-decode";

import {
  getExpensePayment,
  payExpenseDocument,
} from "../../../../api/Expenses/expensePaymentsApi";

import { getExpenseSummary } from "../../../../api/Expenses/expenseDocumentDetailApi";

const ExpensePaymentsTab = ({ documentId, status, onPaid }) => {
  const [payment, setPayment] = useState(null);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🦸 Superman
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const isSuperman = decoded?.permisoVertodoExpenses;

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const [pay, sum] = await Promise.all([
        getExpensePayment(documentId),
        getExpenseSummary(documentId),
      ]);

      setPayment(pay);
      setSummary(sum);
    } catch (e) {
      setError("No se pudo cargar la información de pagos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [documentId]);

  // 💸 Registrar pago
  const handlePay = async () => {
    try {
      await payExpenseDocument(documentId, {
        currency: "EUR",
      });
      await load();
      onPaid?.();
    } catch (e) {
      setError(
        e?.response?.data?.error || "Error registrando el pago del documento"
      );
    }
  };

  if (loading) return null;
  if (!summary) return null;

  // 🔢 Balance
  const diff = summary.totalExpenses - summary.totalAdvances;

  const paymentLabel =
    diff > 0 ? "Pagado al Usuario" : "El Usuario debe devolver dinero";

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* ❌ Documento no listo */}
      {status !== "signed_manager" && status !== "closed" && (
        <Alert severity="info">
          El documento debe estar firmado por usuario y manager antes de pagar.
        </Alert>
      )}

      {/* ✅ Documento cerrado */}
      {status === "closed" && payment && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Pago registrado
          </Typography>

          <Typography>{paymentLabel}</Typography>

          <Typography sx={{ mt: 1 }}>
            Importe: <b>{payment.Amount} €</b>
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Fecha: {new Date(payment.PaymentDate).toLocaleDateString("es-ES")}
          </Typography>
        </Paper>
      )}

      {/* 💸 Listo para pagar */}
      {status === "signed_manager" && !payment && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Pago final
          </Typography>

          <Typography>{paymentLabel}</Typography>

          <Typography sx={{ mt: 1 }}>
            Importe a liquidar: <b>{Math.abs(diff).toFixed(2)} €</b>
          </Typography>

          {isSuperman ? (
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              onClick={handlePay}
            >
              Registrar pago y cerrar documento
            </Button>
          ) : (
            <Alert severity="warning" sx={{ mt: 2 }}>
              Solo un administrador puede registrar el pago.
            </Alert>
          )}
        </Paper>
      )}
    </Box>
  );
};

export default ExpensePaymentsTab;
